
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"currentColor"}},[_c('path',{attrs:{"d":"M12.96 15.7l-2.741 2.74a1.391 1.391 0 01-1.918 0L5.56 15.7a1.358 1.358 0 010-1.919l2.741-2.742a.581.581 0 00-.822-.821l-2.741 2.74a2.519 2.519 0 000 3.563l2.741 2.74a2.516 2.516 0 003.562 0l2.741-2.74a.581.581 0 10-.822-.821zM19.264 7.477l-2.741-2.743a2.521 2.521 0 00-3.563 0l-2.741 2.74a.581.581 0 00.822.822l2.741-2.741a1.361 1.361 0 011.919 0l2.74 2.741a1.359 1.359 0 010 1.919l-2.74 2.741a.581.581 0 00.822.822l2.741-2.742a2.522 2.522 0 000-3.559z"}}),_c('path',{staticClass:"prefix__cls-2",attrs:{"d":"M14.33 8.848l-5.481 5.481a.581.581 0 00.822.822l5.481-5.482a.581.581 0 10-.822-.821z"}})])])
          )
        }
      }
    